import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors, FormControl } from '@angular/forms';
import { AuthService } from '@app-services/auth.service';
import { Admin } from '@app-models/site';
import { ParentErrorStateMatcher, identityValidator, checkInvalid } from '../../../validation';
import { LoadingScreenService } from '@app-services/loading-screen.service';

import { errorMessages } from '../../../../message/error';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  _e = errorMessages.TH;
  userEmail: string;
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  fg: FormGroup;
  pFG: FormGroup;
  authenFailed = false;
  resultFalseMessage: string;
  passwordMatcher: ErrorStateMatcher = new ParentErrorStateMatcher();

  @ViewChild('form') formElementRef: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public admin: Admin,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private _as: AuthService,
    private _fb: FormBuilder,
    private loadingScreenService: LoadingScreenService) {
    if (data) {
      if (data.userEmail) { this.userEmail = data.userEmail; }
      // console.log('userEmail ' + this.userEmail);
    }
    // console.log('userEmail ' + this.userEmail);
  }

  ngOnInit() {
    this.pFG = this._fb.group({
      password: [null, [Validators.required, Validators.minLength(6)]],
      confirmPassword: [null, [Validators.required]]
    }, { validators: [identityValidator('password', 'confirmPassword')] });
    this.fg = this._fb.group({
      currentPassword: ['', [Validators.required]],
      pwd: this.pFG
    });
  }

  onInputConfirmChange() {
    // console.log('box change' + event);
    if (this.fg.get('newPassword').value !== this.fg.get('confirmPassword').value) {
      // console.log('password mismatch!');
      this.fg.get('confirmPassword').setErrors({ 'mismatch': true });
      this.fg.get('confirmPassword').markAsTouched();
    }
  }

  changePassword() {
    this.fg.markAsTouched();
    this.pFG.markAsTouched();
    this.fg.markAsDirty();
    this.pFG.markAsDirty();
    if (!checkInvalid([this.fg, this.pFG], this.formElementRef, true)) {
      this.loadingScreenService.startLoading();
      // console.log('userEmail ' + this.userEmail);
      this.currentPassword = this.fg.get('currentPassword').value;
      this.newPassword = this.pFG.get('password').value;
      // this.confirmPassword = this.pFG.get('confirmPassword').value;
      this._as.changePassword(this.userEmail, this.currentPassword, this.newPassword).then(
        (value: any) => {
          this.dialogRef.close(true);
        }
      ).catch((error: any) => {
        // console.log('error.code :' + error.code);
        // console.log('error :' + error);
        switch (error.code) {
          case 'auth/wrong-password':
            this.fg.get('currentPassword').setErrors({ 'wrongPassword': true });
            this.fg.get('currentPassword').markAsTouched();
            break;
          case 'auth/user-disabled':
            this.resultFalseMessage = this._e.authenDisabled;
            break;
          case 'auth/weak-password':
            this.pFG.get('newPassword').setErrors({ 'wrongPasswordLength': true });
            this.pFG.get('newPassword').markAsTouched();
            break;
          case 'auth/passwordMisMatch':
            this.pFG.get('confirmPassword').setErrors({ 'mismatch': true });
            this.pFG.get('confirmPassword').markAsTouched();
            break;
          default:
            break;
        }
        this.authenFailed = true;
      }).finally(() => {
        this.loadingScreenService.stopLoading();
      });
      // this._as.changePassword('1234abcd');
      // }
    }
  }

}
